import React, { FC, useCallback, ChangeEvent } from 'react';
import { FormikInput } from 'common/form';
import { Form, Formik } from 'formik';
import { SearchIcon } from 'common/icons';
import { MyVehicleItem } from 'api/vehicles';
import { debounce as debounceFunction } from 'throttle-debounce';
import { EmptyMessage, NotFoundDocs } from 'pages/vehicles/components';
import { VehicleItem } from './components/vehicle-item';

import styles from './vehicles.module.scss';

export const Vehicles: FC<any> = props => {
  const { filterBy, goToCheckPoint, goToVehicularDocuments, isLoading, onChangeFilterBy, vehicles } = props;

  const onChange = useCallback(
    debounceFunction(250, (event: ChangeEvent<HTMLInputElement>) => {
      onChangeFilterBy(event.target.value);
    }),
    [],
  );

  return (
    <div className={styles.container}>
      {!(!isLoading && !filterBy && !vehicles?.length) && (
        <Formik initialValues={{ search: filterBy || '' }} onSubmit={() => {}}>
          <Form className={styles.inputContainer}>
            <span className="text-primary">Mis Vehículos</span>
            <FormikInput
              name="search"
              placeholder="Buscar ..."
              prefix={<SearchIcon />}
              type="email"
              wrapperClassName="w-full"
              onChange={onChange}
            />
          </Form>
        </Formik>
      )}

      {!isLoading && !filterBy && !vehicles?.length && <EmptyMessage />}
      {filterBy && !vehicles?.length && <NotFoundDocs />}

      {vehicles?.length > 0 && (
        <div className={styles.listContainer}>
          {vehicles.map((item: MyVehicleItem) => (
            <VehicleItem
              goToCheckPoint={() => goToCheckPoint(item.unique_id)}
              goToVehicularDocuments={() => goToVehicularDocuments(item.unique_id)}
              key={item.unique_id}
              vehicle={item}
            />
          ))}
        </div>
      )}
    </div>
  );
};
